import 'magnific-popup';

const handleImageModal = (trigger = '.js-image-modal') => {
  $(trigger).magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    closeBtnInside: false,
    fixedContentPos: true,
    mainClass: 'mfp-no-margins',
    image: {
      verticalFit: true
    }
  });
}

// handleImageModal();

let clickOnImage = false;

$('.js-image-modal').on('mousedown', function(event) {
  if (event.which === 1) {
    clickOnImage = true;
  }
});

$('.js-image-modal').on('mousemove', function(event) {
  if (event.which === 1) {
    clickOnImage = false;
  }
});

$('.js-image-modal').on('mouseup', function(event) {
  if (event.which === 1 && clickOnImage === true) {
    const imageSrc = $(event.target).data('modal-image-src');

    $.magnificPopup.open({
      items: {
        src: imageSrc
      },
      type: 'image',
      closeOnContentClick: true,
      closeBtnInside: false,
      fixedContentPos: true,
      mainClass: 'mfp-no-margins',
      image: {
        verticalFit: true
      }
    });

    clickOnImage = false;
  }
});
